export const GET_REQUEST_LIST_LOADING = 'GET_REQUEST_LIST_LOADING'
export const GET_REQUEST_LIST_SUCCESS = 'GET_REQUEST_LIST_SUCCESS'
export const GET_REQUEST_LIST_FAILED = 'GET_REQUEST_LIST_FAILED'


export const APPROVE_REQUEST_LIST_LOADING = 'APPROVE_REQUEST_LIST_LOADING'
export const APPROVE_REQUEST_LIST_SUCCESS = 'APPROVE_REQUEST_LIST_SUCCESS'
export const APPROVE_REQUEST_LIST_FAILED = 'APPROVE_REQUEST_LIST_FAILED'


export const DELETE_REQUEST_LIST_LOADING = 'DELETE_REQUEST_LIST_LOADING'
export const DELETE_REQUEST_LIST_SUCCESS = 'DELETE_REQUEST_LIST_SUCCESS'
export const DELETE_REQUEST_LIST_FAILED = 'DELETE_REQUEST_LIST_FAILED'


export const GET_LIST_OF_USER_UNDER_COMPANY_LOADING = 'GET_LIST_OF_USER_UNDER_COMPANY_LOADING'
export const GET_LIST_OF_USER_UNDER_COMPANY_SUCCESS = 'GET_LIST_OF_USER_UNDER_COMPANY_SUCCESS'
export const GET_LIST_OF_USER_UNDER_COMPANY_FAILED = 'GET_LIST_OF_USER_UNDER_COMPANY_FAILED'

export const GET_ORGANISATION_LOADING = "GET_ORGANISATION_LOADING"
export const GET_ORGANISATION_SUCCESS = "GET_ORGANISATION_SUCCESS"
export const GET_ORGANISATION_FAILED = "GET_ORGANISATION_FAILED"


export const GET_ARCHIVE_LIST_LOADING = "GET_ARCHIVE_LIST_LOADING"
export const GET_ARCHIVE_LIST_SUCCESS = "GET_ARCHIVE_LIST_SUCCESS"
export const GET_ARCHIVE_LIST_FAILED = "GET_ARCHIVE_LIST_FAILED"

export const GET_ORGANISATION_DETAILS_LOADING = "GET_ORGANISATION_DETAILS_LOADING"
export const GET_ORGANISATION_DETAILS_SUCCESS = "GET_ORGANISATION_DETAILS_SUCCESS"
export const GET_ORGANISATION_DETAILS_FAILED = "GET_ORGANISATION_DETAILS_FAILED"


export const GET_ORGANISATION_EMPLOYEES_LOADING = "GET_ORGANISATION_EMPLOYEES_LOADING"
export const GET_ORGANISATION_EMPLOYEES_SUCCESS = "GET_ORGANISATION_EMPLOYEES_SUCCESS"
export const GET_ORGANISATION_EMPLOYEES_FAILED = "GET_ORGANISATION_EMPLOYEES_FAILED"


export const UPDATE_LIST_OF_USER_UNDER_COMPANY_LOADING = 'UPDATE_LIST_OF_USER_UNDER_COMPANY_LOADING'
export const UPDATE_LIST_OF_USER_UNDER_COMPANY_SUCCESS = 'UPDATE_LIST_OF_USER_UNDER_COMPANY_SUCCESS'
export const UPDATE_LIST_OF_USER_UNDER_COMPANY_FAILED = 'UPDATE_LIST_OF_USER_UNDER_COMPANY_FAILED'


export const DELETE_LIST_OF_USER_UNDER_COMPANY_LOADING = 'DELETE_LIST_OF_USER_UNDER_COMPANY_LOADING'
export const DELETE_LIST_OF_USER_UNDER_COMPANY_SUCCESS = 'DELETE_LIST_OF_USER_UNDER_COMPANY_SUCCESS'
export const DELETE_LIST_OF_USER_UNDER_COMPANY_FAILED = 'DELETE_LIST_OF_USER_UNDER_COMPANY_FAILED'


export const DELETE_LIST_OF_ORGANISATION_LOADING = 'DELETE_LIST_OF_ORGANISATION_LOADING'
export const DELETE_LIST_OF_ORGANISATION_SUCCESS = 'DELETE_LIST_OF_ORGANISATION_SUCCESS'
export const DELETE_LIST_OF_ORGANISATION_FAILED = 'DELETE_LIST_OF_ORGANISATION_FAILED'

export const ADD_ORGANISATION_LOADING= 'ADD_ORGANISATION_LOADING'
export const ADD_ORGANISATION_SUCCESS = 'ADD_ORGANISATION_SUCCESS'
export const ADD_ORGANISATION_FAILED = 'ADD_ORGANISATION_FAILED'

export const ADD_USER_BY_COMAPNY_ADMIN_LOADING = 'ADD_USER_BY_COMAPNY_ADMIN_LOADING'
export const ADD_USER_BY_COMAPNY_ADMIN_SUCCESS = 'ADD_USER_BY_COMAPNY_ADMIN_SUCCESS'
export const ADD_USER_BY_COMAPNY_ADMIN_FAILED = 'ADD_USER_BY_COMAPNY_ADMIN_FAILED'


export const RESTORE_PROJECT_LOADING= 'RESTORE_PROJECT_LOADING'
export const RESTORE_PROJECT_SUCCESS = 'RESTORE_PROJECT_SUCCESS'
export const RESTORE_PROJECT_FAILED = 'RESTORE_PROJECT_FAILED'